let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cjdHS")).then(() => parcelRequire('iV9jc'));